var _a;
export var StatusCodes;
(function (StatusCodes) {
    StatusCodes[StatusCodes["SUCCESS"] = 200] = "SUCCESS";
    StatusCodes[StatusCodes["OTP_SENT"] = 2001] = "OTP_SENT";
    StatusCodes[StatusCodes["OTP_VERIFY_SUCCESS"] = 2002] = "OTP_VERIFY_SUCCESS";
    StatusCodes[StatusCodes["OTP_VERIFY_FAILED"] = 2003] = "OTP_VERIFY_FAILED";
    StatusCodes[StatusCodes["VERIFICATION_EMAIL_SENT"] = 2007] = "VERIFICATION_EMAIL_SENT";
    StatusCodes[StatusCodes["VERIFICATION_EMAIL_RESENT"] = 2008] = "VERIFICATION_EMAIL_RESENT";
    StatusCodes[StatusCodes["TRIP_CREATED"] = 2100] = "TRIP_CREATED";
    StatusCodes[StatusCodes["TRIP_UPDATED"] = 2101] = "TRIP_UPDATED";
    StatusCodes[StatusCodes["USER_ALREADY_EXISTS"] = 4001] = "USER_ALREADY_EXISTS";
    StatusCodes[StatusCodes["ERROR"] = 5000] = "ERROR";
})(StatusCodes || (StatusCodes = {}));
export var StatusMessages = (_a = {},
    _a[StatusCodes.SUCCESS] = "Action completed successfully",
    _a[StatusCodes.OTP_SENT] = "OTP has been sent to your email.",
    _a[StatusCodes.OTP_VERIFY_SUCCESS] = "OTP successfully verified.",
    _a[StatusCodes.OTP_VERIFY_FAILED] = "Invalid OTP or OTP has expired.",
    _a[StatusCodes.VERIFICATION_EMAIL_SENT] = "A verification email has been sent to your email.",
    _a[StatusCodes.VERIFICATION_EMAIL_RESENT] = "A new verification email has been sent to your email.",
    _a[StatusCodes.TRIP_CREATED] = "Trip created.",
    _a[StatusCodes.TRIP_UPDATED] = "Trip updated.",
    _a[StatusCodes.USER_ALREADY_EXISTS] = "User already exists. Please use a different email.",
    _a[StatusCodes.ERROR] = "Something went wrong. Please try again.",
    _a);
